import { LoginEndpoint } from '@futmanager/api-sdk'
import { useUserStore } from '~/store'

export function useAuth() {
  const userStore = useUserStore()

  async function checkToken() {
    try {
      const { data } = await LoginEndpoint.token()
      userStore.setUser(data.user)
      return Boolean(userStore.user)
    }
    catch {
      return false
    }
  }

  return {
    checkToken,
  }
}
